export const defaultOnChangeFieldRequiredForMatching = (callback: VoidFunction) =>
    new Promise((resolve) => resolve(callback()));
